import LogRocket from 'logrocket';
import _ from 'lodash';
import store from '../store/configureStore';
import Logger from './Logger';

const ENV = window.location.hostname.slice(0, 3);
const LOGROCKET_APP_ID = 'hak7ik/popin-' + ENV;

// only enable in PRD
const LOGROCKET_ENABLED = ENV === 'app';

// enable recording for 2% of the users
const LUCKY_RANDOM_PERSON = Math.random() < 0.02;

const isPOPinUserInPRD = (user) => {
  return ENV === 'app' && user && user.email && user.email.endsWith('@popinnow.com');
};

const isEnableRecording = (user) => {
  /*
    Qualify user if:
    1. User object not provided / guest / new user OR
    2. User is signed up via auto tenant flow OR
    3. User has launched a POPin OR
    4. User is the lucky 10%
  */
  const isQualified = !user || user.is_self_sign_up || user.has_self_launched || LUCKY_RANDOM_PERSON;
  return LOGROCKET_ENABLED && !isPOPinUserInPRD(user) && isQualified;
};

// Is this user being recorded
let isRecordingUser = false;

export class ScreenRecorder {

  static record (force) {
    const user = store.getState().user.user;
    if ((force || isEnableRecording(user)) && LogRocket) {
      LogRocket.init(LOGROCKET_APP_ID);
      ScreenRecorder.identify();
    }
  }

  static identify () {
    const user = store.getState().user.user;
    if (user && LogRocket) {
      // identify user
      LogRocket.identify(user.id, {
        name: user.display_name,
        email: user.email,
        tenant_name: _.get(user, 'tenant.name'),
        tenant_industry: _.get(user, 'tenant.industry'),
        tenant_org_dash_enabled: _.get(user, 'tenant.org_dashboard_enabled'),
        tenant_trial: _.get(user, 'tenant.trial'),
        plan_id: _.get(user, 'plan.id'),
        plan_name: _.get(user, 'plan.name'),
        product: user.product,
        is_self_sign_up: user.is_self_sign_up,
        has_self_launched: user.has_self_launched,
        event_creation_allowed: user.event_creation_allowed,
        guest: user.guest,
        is_tenant_account_owner: user.is_tenant_account_owner,
        is_grace_period: user.is_grace_period,
        role_type: user.role_type,
        admin_viewing_as: user.admin_viewing_as
      });
    }
  }

  static trackCustomAction(action) {
    if (!!isRecordingUser) {
      if (LogRocket) {
        Logger.d('ScreenRecorder: Track custom action: ', action);
        LogRocket.track(action);
      }
    }
  }

}
